var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 9.407999992370605,
    height: 17.920000076293945,
    viewBox: "0 0 9.407999992370605 17.920000076293945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.272,10.304L8.512,10.304L9.408,6.72L6.272,6.72L6.272,4.928C6.272,4.00512,6.272,3.136,8.064,3.136L9.408,3.136L9.408,0.12544C9.1159,0.0869121,8.01293,0,6.84813,0C4.41549,0,2.688,1.48467,2.688,4.2112L2.688,6.72L0,6.72L0,10.304L2.688,10.304L2.688,17.92L6.272,17.92L6.272,10.304Z",
    fill: "#EFEFEF",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a7ef4ada599e6c342f24b01c9fcaedd9.svg";
export { ForwardRef as ReactComponent };